// src/lib/api/axios.ts
import { siteConfig } from '@/config/site'
import axios from 'axios'
import camelcaseKeys from 'camelcase-keys'
import Cookies from 'js-cookie'
import snakecaseKeys from 'snakecase-keys'

interface AxiosErrorDetail {
  key: string
  code: number
}

const HttpMethodsSnakecase = ['delete', 'put', 'patch', 'post']
const exclude = ['redirectUrl']

export const axiosInstance = axios.create({
  baseURL: siteConfig.apiUrl,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
})

axiosInstance.interceptors.request.use(config => {
  const token = Cookies.get(siteConfig.tokenKey || '')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  const { method, data, params } = config
  if (method && HttpMethodsSnakecase.includes(method) && !!data) {
    config.data = snakecaseKeys(data)
  } else if (method === 'get' && !!params) {
    config.params = snakecaseKeys(params, { exclude })
  }
  return config
})

axiosInstance.interceptors.response.use(
  response => {
    const { status, data } = response.data
    if (status) {
      return camelcaseKeys(data, { deep: true })
    }
    // 正常不會跑來這
    return response
  },
  error => {
    const { response } = error
    if (!response) {
      return Promise.reject(error.message)
    }
    const { code, message: key } = response.data
    if (window) {
      window.dispatchEvent(
        new CustomEvent<AxiosErrorDetail>('apiError', {
          detail: {
            key,
            code,
          },
        }),
      )
    }
    return Promise.reject(error)
  },
)
